// extracted by mini-css-extract-plugin
export var dropdownContainer = "_s3-0";
export var leftAlign = "_s3-4";
export var listItem = "_s3-2";
export var listItemWrapper = "_s3-1";
export var operationText = "_s3-3";